import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import EmailVerification from './EmailVerification';

const ProtectedRoute = ({ children }) => {
  const { currentUser, userData, loading } = useAuth(); 
  const location = useLocation();
  const [emailVerified, setEmailVerified] = React.useState(true);

  React.useEffect(() => {
    console.log('🛡️ ProtectedRoute: Current user changed:', currentUser ? currentUser.email : 'null');
    console.log('🛡️ ProtectedRoute: User data:', userData);
    console.log('🛡️ ProtectedRoute: Loading state:', loading);
    console.log('🛡️ ProtectedRoute: Current path:', location.pathname);
    
    if (currentUser && !currentUser.emailVerified) {
      setEmailVerified(false);
    } else {
      setEmailVerified(true);
    }
  }, [currentUser, userData, loading, location.pathname]);

  // Protected route logic

  // =================================================================
  // INICIO: LÓGICA DE PROTECCIÓN CENTRALIZADA Y CORRECTA
  // =================================================================

  // 1. Si la autenticación está en proceso, mostrar un loader.
  // Esto es CRÍTICO para esperar a que los datos de Firestore (onboardingCompleted) lleguen.
  if (loading) {
    return <LoadingSpinner />;
  }

  // 2. Si no hay usuario, redirigir a /auth/login.
  if (!currentUser) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // 3. Si el email no está verificado, mostrar el componente de verificación.
  if (!emailVerified) {
    return <EmailVerification />;
  }

  // Lógica de Onboarding basada en userData
  if (userData) {
    if (!userData.onboardingCompleted) {
      // Solo forzar onboarding si está intentando acceder a rutas /admin/* (excepto onboarding)
      if (location.pathname.startsWith('/admin/') && location.pathname !== '/admin/onboarding') {
        console.log('🚫 ProtectedRoute: User without onboarding trying to access admin area, redirecting to onboarding...');
        return <Navigate to="/admin/onboarding" replace />;
      }
    } else { // userData.onboardingCompleted es true
      // Si ya completó onboarding y está intentando acceder a login, register u onboarding, mandarlo al dashboard
      if (location.pathname === '/auth/login' || location.pathname === '/auth/register' || location.pathname === '/admin/onboarding') {
        console.log('🔄 ProtectedRoute: User with completed onboarding accessing auth/onboarding, redirecting to dashboard...');
        return <Navigate to="/admin/dashboard" replace />;
      }
    }
  } else if (currentUser) {
    // Hay sesión pero los datos del negocio todavía no llegaron.
    //
    // Acá había un `Navigate` al onboarding "por ahora": con la sesión a medio
    // cargar no se sabe si completó el onboarding, y se resolvía asumiendo que
    // no. Para alguien que ya lo completó eso era mostrarle una pantalla que no
    // le corresponde y sacársela un instante después, que es el parpadeo que se
    // veía al entrar.
    //
    // "Todavía no sé" no es "no completó": lo que corresponde es esperar. El
    // arreglo de fondo está en AuthContext (`loading` vuelve a true en cada
    // cambio de sesión); esto queda como red, porque mandar a alguien al
    // onboarding por no tener un dato es un error del que no se vuelve solo.
    console.log('⏳ ProtectedRoute: sesión a medio cargar, esperando los datos del negocio...');
    return <LoadingSpinner />;
  }
  
  // 5. Si ninguna de las condiciones anteriores se cumple, el usuario tiene acceso.
  return children;
  
  // =================================================================
  // FIN: LÓGICA DE PROTECCIÓN CENTRALIZADA Y CORRECTA
  // =================================================================
};

export default ProtectedRoute; 